import { NotSupportedError } from "./errors/index";

export function expect<T>(value?: T) {
  return {
    toBeDefined(errorMessage?: string): T {
      if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
        throw new Error(errorMessage ?? 'The value is not defined.');
      }
      return value;
    },
    toThrowNotSupported(errorMessage: string) {
      throw new NotSupportedError(errorMessage);
    }
  }
}